import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import './FeatureCard.css';

export interface FeatureCardProps {
  icon: IconDefinition;
  title: string;
  description: string;
}

const FeatureCard = ({ icon, title, description }: FeatureCardProps) => {
  return (
    <div className="nova-feature-card">
      <div className="nova-feature-icon">
        <FontAwesomeIcon icon={icon} />
      </div>
      <div className="nova-feature-body">
        <h3 className="nova-feature-title">{title}</h3>
        <p className="nova-feature-description">{description}</p>
      </div>
    </div>
  );
};

export default FeatureCard;
